import { createContext, useContext } from "react";
import HosProcess from "../../../services/hosProcess";


export class HosUtilsContextType {
    constructor (public hosUtils: HosProcess) {}
}

export const HosUtilsContext = createContext<HosUtilsContextType | undefined>(undefined);

export const useHosUtilsContext = (): HosUtilsContextType => {
    const context = useContext(HosUtilsContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the HosUtilsContext");
    }
    return context;
};